// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrapper[data-v-9a08a7f6]{height:44px;display:flex;margin:0 12px;padding:10px 12px;width:216px;color:#a4b4d0;font-size:13px;font-style:normal;font-weight:700;line-height:20px;cursor:pointer}.wrapper .icon[data-v-9a08a7f6]{width:24px;height:24px;margin-right:10px}.wrapper .num[data-v-9a08a7f6]{font-weight:400;margin-left:20px}.con[data-v-9a08a7f6]{margin-bottom:4px}", ""]);
// Exports
module.exports = exports;
